import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.file-select-all-button': {
    color: COLORS.PRIMARY500,
    minWidth: 'unset',
    '&--none-selected': {
      color: COLORS.NEUTRAL800,
    },
  },
  '.file-select-all-button': {
    '&__icon': {
      marginRight: theme.space[4],
    },
  },
});
